<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  maxValue: {
    type: Number,
    required: true
  },
  currentValue: {
    type: Number,
    required: true
  },
  reverse: {
    type: Boolean,
    default: false
  }
});

const mascotImageStyle = computed(() => {
  const left = `${(props.currentValue - 1) * (100 / (props.maxValue - 1))}%`;
  return {
    left: left,
    marginLeft: "-1rem",
    width: "2rem",
    bottom: "0"
  };
});
const barStyle = computed(() => {
  const width = `${(props.currentValue - 1) * (100 / (props.maxValue - 1))}%`;
  return {
    width: width
  };
});
</script>

<template>
  <div>
    <div class="position-relative mascot-outer">
      <img
        class="position-absolute"
        src="@/assets/img/caikuma_running.png"
        data-testid="mascot-image"
        :style="mascotImageStyle"
      />
    </div>
    <div class="mt-2 stepbar">
      <div class="bar">
        <div class="active" data-testid="bar" :style="barStyle" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mascot-outer {
  height: 2.25rem;
  margin: 0 12px;
}

.stepbar {
  position: relative;

  .bar {
    position: absolute;
    top: calc(50% - 3px / 2);
    width: 100%;
    height: 10px;
    background-color: $gray-03;
    border-radius: 5px;

    .active {
      height: 100%;
      background-color: $primary;
      border-radius: 5px;
    }
  }
}
</style>
